<template>
	<div id="newsSource" data-role="page">
		<!-- content -->
		<div class="newsSource-content" data-position="fixed">
			<div class="detailWrap">
				<div class="top-area">
					<div>
						<img :src="' https://storage.googleapis.com/kingnetcare/CHK/committee/official/'+offiec.legal_id+'/logo.jpg'" alt="">
						<h2>{{offiec.name}}</h2>
						<div class="contactDiv">
							<p>{{offiec.address}}</p>
							<p>{{offiec.tel}}</p>
						</div>
					</div>
				</div>
                <div class="about-area">
					<h3>關於我們</h3>
					<!-- 圖文插入開始 -->
					<div class="desc">
                        <p v-html="offiec.content"></p>
					</div>
					<!-- /圖文插入結束 -->
				</div>
			</div>
		</div>
		<!-- /content -->
		<!-- footer -->
    <div class="qk-link" v-if="offiec.multiLink.length>0">
        <div :class="{'qk-link-wrap-col1' : offiec.multiLink.length == 1 ,'qk-link-wrap-col2' : offiec.multiLink.length == 2 ,'qk-link-wrap-col3' : offiec.multiLink.length == 3}">
          <div v-for="(LinkBtn,LinkBtn_ind) in offiec.multiLink" v-on:click="windowsOpen(LinkBtn.link)" :key="LinkBtn_ind"><span>{{LinkBtn.name}}</span></div>
        </div>               
    </div>
        <!-- /footer -->
	</div>
</template>

<script lang="js">
export default {
  data () {
    return {
      offiec:[]
    }
  },
  mounted(){
      this.GetOfficeDetail();
  },
  methods:{
      GetOfficeDetail(){
        let vobj=this;
        let legalId = this.$route.params.id;
        this.axios.get(`${process.env.ExternalApi}/api/ExternalControllers/Committee/GetCommitteeLegalOfficialDetail/${legalId}` ,{
            headers:{Authorization: Token}
        }).then((response) => {
            if(response.status == 200){
                vobj.offiec =  response.data.data
                console.log(vobj.offiec);
            }
        })
      },
      windowsOpen(url){
          window.open(url,'_system');
      }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/newsSource.vue